import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

// Loading placeholder for the coach's My Program page — gradient header, then a
// stack of settings cards (each a heading with a few option rows).
export default function CoachPreferencesSkeleton({ isDarkMode }) {
    const cardCls = `rounded-2xl border p-6 mb-6 ${isDarkMode ? "bg-slate-800 border-slate-700" : "bg-white border-slate-200 shadow-sm"}`;
    const baseColor = isDarkMode ? "#334155" : "#e2e8f0";
    const highlightColor = isDarkMode ? "#475569" : "#f1f5f9";

    return (
        <SkeletonTheme baseColor={baseColor} highlightColor={highlightColor}>
            <div className={`min-h-screen ${isDarkMode ? "bg-surface" : "bg-surface"}`}>
                <div className="max-w-5xl mx-auto px-4 py-8">
                    <div className="mb-8"><Skeleton height={112} borderRadius={16} /></div>

                    {Array.from({ length: 3 }).map((_, c) => (
                        <div key={c} className={cardCls}>
                            <Skeleton width={200} height={20} className="mb-2" />
                            <Skeleton width={320} height={13} className="mb-4" />
                            <div className="space-y-3">
                                {Array.from({ length: 3 }).map((_, r) => (
                                    <div key={r} className="flex items-center gap-3">
                                        <Skeleton width={20} height={20} borderRadius={6} />
                                        <Skeleton height={14} width={`${60 + r * 8}%`} />
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </SkeletonTheme>
    );
}
